var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grid-container" }, [
    _c(
      "div",
      { staticClass: "action action--page" },
      [
        _vm.showPrevButton
          ? [
              _vm.prevButtonRouter
                ? _c(
                    "router-link",
                    {
                      staticClass: "button button--prev",
                      attrs: {
                        to: _vm.prevButtonRouter,
                        tag: "button",
                        title: _vm.$t("prev_page"),
                        tabindex: "-1",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("prev_page")))]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button button--prev",
                      attrs: {
                        role: "button",
                        title: _vm.$t("prev_page"),
                        tabindex: "-1",
                      },
                      on: { click: _vm.onClickPrevAction },
                    },
                    [_vm._v(_vm._s(_vm.$t("prev_page")))]
                  ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("h1", { class: { "u-no-margin--bottom": _vm.$slots.default } }, [
              _vm._v(_vm._s(_vm.title)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }